import { AppEnvironment } from 'src/environments/AppEnvironment';

import { environment } from '../../environments/environment';

export enum API_VERSIONS {
	API_VERSION_ONE = 1,
	API_VERSION_TWO,
}

const BASE_URL: string = `${environment.apiEndpointOrigin}/${environment.apiVersion}`;
// const BASE_URL: string = `https://localhost:44317/api/v1`;
// const ORCHESTRATOR: string = `quoteengineorchestrator-dev`;
const getBaseUrl = (version: number): string => `${environment.apiEndpointOrigin}/v${version}`;
// eslint-disable-next-line
export const CDN_BASE: string = `https://epiassets.azureedge.net/assets${[AppEnvironment.DEV, AppEnvironment.RC, AppEnvironment.LOCAL].includes(environment.appEnvironment) ? '-dev' : ''}`;

export const RESOURCES = {
	QUOTE: `quote`,
	RETRIEVE_QUOTE: `retrievequote`,
	PET: `pet`,
	BREED: `breed`,
	BRAND: `brand`,
	PARTNER: `partner`,
	CONTACT: `contact`,
	PURCHASE: `purchase`,
	VET_CLINIC: `vetclinic`,
	SAVE: `save-and-sync`,
	STATE: `state`,
	SHOULD_MEMBER_NUMBER_REDIRECT: `ShouldMemberNumberRedirect`,
	COVERAGE: `coverages`,
	VALIDATION: `validation`,
	CHECKOUT: `checkout`,
};

export const getEndpoint = (...args: string[]): string => {
	const paths: string[] = [
		BASE_URL,
		// ORCHESTRATOR,
		...args,
	];

	return paths.join(`/`);
};

export const getVersionedEndpoint = (
	version: number,
	...args: string[]
): string => (
	[
		getBaseUrl(version),
		...args,
	].join(`/`)
);

export const getCdnAsset = (...args: string[]): string => [CDN_BASE, ...args].join(`/`);

export const STYLESHEET_BASE: string = `whitelabel/styles`;
export const LOGO_BASE: string = `whitelabel/logos`;

export const RETRIEVE_TYPES = {
	WEB: `web`,
	SMS: `sms`,
	QEV3: 'quoteenginev3',
	PAGE_3: 'page3',
};
